/* Carter · comportamenti
   1) segnala se la pagina ha l'hero, e quanto è alta la barra countdown
   2) se il menu è fisso, lo stacca all'arrivo della striscia
   3) il video del film accende l'audio quando la sezione è in vista
*/
(function(){

  if (window.__carterV3) return;
  window.__carterV3 = true;

  /* ------------------------------------------- 1. che pagina è, e misure */
  function misura(){
    /* la barra countdown può essere spenta dal pannello: allora vale zero */
    var b = document.querySelector('.carter-topbar');
    var h = (b && b.offsetHeight) ? b.offsetHeight : 0;
    document.documentElement.style.setProperty('--carter-topbar-h', h + 'px');

    /* riserva per i browser che non conoscono :has() */
    var casa = !!document.querySelector('.carter-hero');
    document.documentElement.classList.toggle('carter-home', casa);
  }

  /* ------------------------------------------------------------- 2. menu
     Serve solo se il menu è davvero fisso allo schermo. Se è sovrapposto
     in modo assoluto scorre via da solo con la pagina: spostarlo di nuovo
     lo farebbe salire il doppio. */
  var menuPronto = false;
  function menu(){
    if (menuPronto) return;
    var nav = document.querySelector('.carter.carter-nav');
    var stop = document.querySelector('.carter-marquee');
    if (!nav || !stop) return;
    if (getComputedStyle(nav).position !== 'fixed') return;
    menuPronto = true;

    var pendente = false;
    function calcola(){
      pendente = false;
      var barra = parseFloat(getComputedStyle(document.documentElement)
                    .getPropertyValue('--carter-topbar-h')) || 0;
      var altezza = nav.offsetHeight;
      var fondo = barra + altezza;              /* dove finisce il menu */
      var arrivo = stop.getBoundingClientRect().top;
      var d = Math.min(0, arrivo - fondo);      /* 0 finché la striscia è sotto */
      nav.style.transform = d ? 'translateY(' + d + 'px)' : '';
    }
    function chiedi(){
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(calcola);
    }

    document.addEventListener('scroll', chiedi, true);
    window.addEventListener('resize', function(){ misura(); chiedi(); });
    calcola();
  }

  /* -------------------------------------------------------- 3. audio film */
  function audio(){
    var p = document.querySelector('.carter-film .player');
    if (!p || p.dataset.carterAudio) return;
    var v = p.querySelector('video');
    if (!v) return;
    p.dataset.carterAudio = '1';

    var inVista = false;

    function permesso(){
      return !navigator.userActivation || navigator.userActivation.hasBeenActive;
    }

    function riparti(){
      var r = v.play();
      if (r && r.catch) r.catch(function(){});
    }

    function accendi(){
      if (!inVista || p.dataset.manuale) return;
      if (!permesso()) { armaGesto(); riparti(); return; }

      v.muted = false;
      p.classList.add('audio-on');
      var r = v.play();
      if (r && r.catch) r.catch(function(){
        v.muted = true;
        p.classList.remove('audio-on');
        riparti();
        armaGesto();
      });
    }

    function spegni(){
      v.muted = true;
      p.classList.remove('audio-on');
    }

    var armato = false;
    function armaGesto(){
      if (armato) return;
      armato = true;
      function una(){
        ['pointerdown','touchstart','keydown','click'].forEach(function(e){
          window.removeEventListener(e, una, true);
        });
        armato = false;
        setTimeout(accendi, 0);
      }
      ['pointerdown','touchstart','keydown','click'].forEach(function(e){
        window.addEventListener(e, una, { capture:true, passive:true });
      });
    }

    var tasto = p.querySelector('.sound');
    if (tasto) tasto.addEventListener('click', function(){
      p.dataset.manuale = '1';
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(voci){
      voci.forEach(function(e){
        if (e.isIntersecting && e.intersectionRatio >= .55){
          inVista = true; accendi();
        } else if (e.intersectionRatio < .3){
          inVista = false; spegni();
        }
      });
    }, { threshold:[0, .3, .55, .8] });
    io.observe(p);

    armaGesto();
  }

  function init(){ misura(); menu(); audio(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function(){ misura(); init(); });
  document.addEventListener('shopify:section:load', init);
})();
